import useErrorModal from "./useErrorModal";

const useLectureValidation = () => {
    const { showErrorModal, ErrorModal } = useErrorModal();

    const validateLecture = (file: File): Promise<string | null> => {
        return new Promise((resolve, reject) => {
            if (!file.name.endsWith(".pptx")) {
                showErrorModal('Не удалось загрузить лекцию', 'Файл должен быть формата .pptx');
                resolve('Файл должен быть формата pptx');
                return;
            }

            if (file.size > 4 * 1024 * 1024 * 1024) {
                showErrorModal('Не удалось загрузить лекцию', 'Файл не должен превышать размер 4 ГБ');
                resolve('Файл не должен превышать размер 4 ГБ');
                return;
            }

            resolve(null);
        });
    };

    return { validateLecture, ErrorModal };
};

export default useLectureValidation;
